import { useLocalStorage } from 'usehooks-ts'

import { usePathname, useSearchParams } from 'next/navigation'

export function useCartReturnUrl() {
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const [returnUrl, setReturnUrl] = useLocalStorage<string | null>('cart-back-url', null)

    const setCartBackReturnUrl = () => {
        const url = searchParams.size ? `${pathname}?${searchParams}` : pathname
        setReturnUrl(url)
    }

    return { returnUrl, setCartBackReturnUrl }
}
